module.exports = __webpack_public_path__ + "assets/img/7ea29476ec16829321ecadbf2c063c29.png";